module.exports = __webpack_public_path__ + "media/ferulic-small.fe42c8a6.mp4";